var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-bottom-navigation',{staticClass:"bottom-bar spotlight",attrs:{"app":"","width":"100vw","flat":""}},_vm._l((_vm.items),function(item){return _c('NavTileComponent',{key:item.route.name,attrs:{"route":item.route,"title":item.title,"icon":item.icon,"count":item.count,"asButton":""}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }